import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
@Component({
  selector: 'app-not-interested-leads',
  templateUrl: './not-interested-leads.component.html',
  styleUrls: ['./not-interested-leads.component.css']
})
export class NotInterestedLeadsComponent implements OnInit {

  type: any;
  serviceType: string = '';
  selectedServiceType: string = '';

  userTypeName: string = '';
  leads: Array<any> = []
  allStaffRecords: any;
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    public lookupModel: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.getStaff();
    this.serviceType = this.lookupModel.getSelectedServiceType() ? this.lookupModel.getSelectedServiceType() : 'realEstate';
    this.selectedServiceType = this.serviceType
    this.typeServices('', this.serviceType)

  }
  getStaff(): void {
    this.rsbService.getStaffData(this.type ? this.type : 'subfranchise').subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }
  addStaff(): void {
  }
  typeServices(userType: string, serType: string): void {
    this.serviceType = serType;
    if (serType === 'realEstate') {
      this.rsbService.getAssignedFranchiseLeadsForFranchise({ "status": 3 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'finTech') {
      this.rsbService.getAssignedFintechLeadsForFranchise({ "status": 3 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0) {
          this.leads = rsp.contents;
        } else {
          this.leads = [];
        }
      });
    } else if (serType === 'propService') {
      this.rsbService.getAssignedPropServiceLeadsForFranchise({ "status": 3 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0) {
          this.leads = rsp.contents;
        } else {
          this.leads = [];
        }
      });
    } else {
      alert('Something went wrong');
    }
  }
  selectService(service: string) {
    this.selectedServiceType = service;
    this.lookupModel.setSelectedServiceType(this.selectedServiceType);
    this.serviceType = this.selectedServiceType;
    this.typeServices(this.lookupModel.getLoggedUser().type, service);
  }

}


